
import homePageData from "../../data/homePage";
import dnsPageData from "../../data/dns";
import Calculator from "../../components/vps/calculator.vue";
import Customers from "../../components/vps/customers.vue";
import Os from "../../components/vps/os.vue";
import Benefits from "../../components/vps/benefits.vue";
import Modal from "../../components/rebranding/modal/Modal.vue";
import Uses from "../../components/vps/uses.vue";
import Plans from "../../components/cdn/plans.vue";

export default {
  components: {
    Calculator,
    Os,
    Customers,
    Plans,
    Benefits,
    Modal,
    Uses,
    Plans,
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "DNS ابری رایگان | دی ان اس سریع و با آپ‌تایم بالا | آبالون",
      meta: [
        {
          name: "description",
          content:
            "با استفاده از DNS ابری آبالون، رکوردهای دامنه خود را به سادگی مدیریت کرده و به رایگان و با دسترسی همیشگی، در تمام جهان منتشر کنید.",
        },
        {
          name: "keywords",
          content: "dns ابری رایگان, DNS رایگان, cloud dns",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/dns",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "DNS ابری رایگان | دی ان اس سریع و با آپ‌تایم بالا | آبالون",
        },
        {
          property: "og:description",
          content:
            "با استفاده از DNS ابری آبالون، رکوردهای دامنه خود را به سادگی مدیریت کرده و به رایگان و با دسترسی همیشگی، در تمام جهان منتشر کنید.",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/dns",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          title: "DNS ابری رایگان | دی ان اس سریع و با آپ‌تایم بالا | آبالون",
        },
        {
          name: "twitter:description",
          content:
            "با استفاده از DNS ابری آبالون، رکوردهای دامنه خود را به سادگی مدیریت کرده و به رایگان و با دسترسی همیشگی، در تمام جهان منتشر کنید.",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/dns",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "آیا استفاده از خدمات DNS ابری رایگان است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. برای خرید DNS آبالون نیازی به پرداخت هیچ‌گونه هزینه‌ای ندارید و سرویس DNS ابری آبالون کاملا رایگان و بدون هرگونه محدودیت است. به عبارت دیگر هیچ محدودیتی در تعداد رکوردها، تعداد درخواست‌های ارسال شده به سمت سرورها و سرعت پاسخگویی به درخواست‌ها وجود ندارد.",
                },
              },
              {
                "@type": "Question",
                name: "در حال حاضر دامنه‌های من روی DNS‌ دیگری است. آیا می‌توانم به سادگی دامنه‌های خود را به DNS رایگان آبالون منتقل کنم؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. کافی‌ست وارد پنل کاربری آبالون شوید و از منوی «محافظت ابری»، دامنه مورد نظر خود را اضافه کنید. سپس به پنل وب‌سایتی که دامنه را از آن خریداری کرده‌اید مراجعه کرده و اطلاعات سرورهای آبالون را وارد نمایید.",
                },
              },
              {
                "@type": "Question",
                name: "خدمات DNS ابری آبالون چه تفاوتی با سایر DNSها دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با کمک DNS ابری آبالون می‌توانید رکوردهای مرتبط با دامنه‌های خود را به سادگی و رایگان مدیریت کنید و به این منظور نیازی به طی کردن فرایند پیچیده راه‌اندازی و مدیریت سرورهای DNS‌ ندارید. علاوه بر این به لطف سرورهای متعدد در سراسر ایران و جهان، در دسترس بودن همیشگی سرویس DNS‌ ابری تضمین می‌شود.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "DNS ابری آبالون",
            },
            author: {
              "@type": "Person",
              name: "Hamid Karimi",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      tabItems: dnsPageData.tabItems,
      solotionTabItems: dnsPageData.solotionTabItems,
      benefits: homePageData.benefits,
      dataBlog: homePageData.dataBlog,
      questions: dnsPageData.questions,
      dnsUses: dnsPageData.dnsUses,
      PopularServices: dnsPageData.PopularServices,
      serviceFeatures: dnsPageData.serviceFeatures,
      scrubbingCenter: dnsPageData.scrubbingCenter,
      cdnCoverage: dnsPageData.cdnCoverage,
      uses: homePageData.uses,
      locations: homePageData.locations,
      activeSection: "",
      tab: 0,
      solotionTab: 0,
      showmore: false,
    };
  },
  mounted() {},
  methods: {
    playVid() {
      var vid = document.getElementById("myVideo");

      vid.play();
    },

    pauseVid() {
      var vid = document.getElementById("myVideo");

      vid.pause();
    },
    spliceNumber(number) {
      if (number != null) {
        number = Math.round(number);
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
    },
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
    customizePlan() {
      for (let value of this.data.plan)
        if (this.request.price != value.price) {
          delete this.request.plan;
          this.selectedPlan = null;
        }
    },
    showMore() {
      this.showmore = true;
    },
  },
};
